/* Bioactive Retention (condensed) — storefront behavior.
   Replaces the original React component's two interactions:
     1. Dials sweep from empty to their target when scrolled into view.
     2. Cards expand their blurb on hover (CSS) or tap (toggle .is-open here),
        single-open at a time, keyboard accessible. */
(function () {
  function init(root) {
    if (!root || root.dataset.tdBioInit === "1") return;
    root.dataset.tdBioInit = "1";

    // ── Tap / keyboard toggle (one card open at a time) ──
    var cards = root.querySelectorAll(".cl-card");
    function closeAll(except) {
      cards.forEach(function (c) {
        if (c !== except) {
          c.classList.remove("is-open");
          c.setAttribute("aria-expanded", "false");
        }
      });
    }
    cards.forEach(function (card) {
      function toggle() {
        var open = card.classList.toggle("is-open");
        card.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) closeAll(card);
      }
      card.addEventListener("click", toggle);
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    });

    // ── Dial sweep when the panel scrolls into view ──
    // Rings are rendered FILLED by default (graceful no-JS fallback). When JS
    // and motion are available we reset them to empty, then sweep to target as
    // the panel enters the viewport.
    var fills = root.querySelectorAll(".cl-ring-fill");
    function fill() {
      fills.forEach(function (c) {
        c.style.strokeDashoffset = c.getAttribute("data-target");
      });
    }
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      return; // leave dials in their default filled state
    }
    // Reset to empty (no transition for the reset), then animate on view.
    fills.forEach(function (c) {
      var prev = c.style.transition;
      c.style.transition = "none";
      c.style.strokeDashoffset = c.getAttribute("stroke-dasharray");
      // force reflow so the reset is committed before re-enabling transition
      void c.getBoundingClientRect();
      c.style.transition = prev;
    });
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          fill();
          obs.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll(".td-bioactive").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Re-init inside the Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector ? e.target.querySelector(".td-bioactive") : null;
    if (el) init(el);
  });
})();
